import { FC } from "react";
import { BooleanField, Datagrid, List, ReferenceField, TextField } from "react-admin";

import CustomPagination from "../../../components/CustomPagination";
import EmptyDataText from "../../../components/EmptyDataText";
import TimestampField from "../../../components/TimestampField";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useIsAdmin from "../../../hooks/useIsAdmin";
import useIsCoach from "../../../hooks/useIsCoach";
import useUpdateListNotifications from "../../../hooks/useUpdateListNotifications";
import { AppResource } from "../../../types/resource.types";
import { coachDocRef } from "../../../utils/referencies";
import CanceledBy from "./components/CanceledBy";
import CancelReservation from "./components/CoachsReservationsActions/CancelReservation";
import ReservationsFilters from "./components/CoachsReservationsFilter";
import ReservationsStatusText from "./components/ReservationsStatusText";
import ReservationsTime from "./components/ReservationsTime";
import SportType from "./components/SportType";

const CoachReservationsList: FC<any> = (props) => {
  const { isCoach } = useIsCoach();
  const { isAdmin } = useIsAdmin();
  const { user } = useCurrentUser();

  useUpdateListNotifications(
    coachDocRef(user.id as string),
    AppResource.coachReservations,
    AppResource.reservationLastSeenAt
  );

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      filters={<ReservationsFilters isCoach={isCoach} isAdmin={isAdmin} userId={user.id} />}
      exporter={false}
    >
      <Datagrid empty={<EmptyDataText message="No reservations yet!" />}>
        <ReferenceField
          label="Client"
          source="clientId"
          reference={`${AppResource.clients}`}
          sortable={false}
          link={false}
        >
          <TextField source="displayName" />
        </ReferenceField>
        <ReferenceField
          label="Phone"
          source="clientId"
          reference={`${AppResource.clients}`}
          sortable={false}
          link={false}
        >
          <TextField source="phoneNumber" />
        </ReferenceField>

        {isAdmin ? (
          <ReferenceField
            label="Coach"
            source="coachId"
            reference={`${AppResource.coaches}`}
            sortable={false}
            link={false}
          >
            <TextField source="displayName.en" />
          </ReferenceField>
        ) : null}
        <BooleanField source="indoor" label="In House" sortable={false} />
        <ReservationsTime source="firstSlotTime" label="Reservation Time" />
        <TextField source="paymentMethod" />
        <TimestampField source="createdAt" label="Created At" />
        <ReservationsStatusText source="status" label="Status" sortable={false} />
        <SportType label="Sport Type" />
        {isCoach ? <CanceledBy label="Canceled By" /> : null}
        {isCoach ? <CancelReservation /> : null}
      </Datagrid>
    </List>
  );
};

export default CoachReservationsList;
